import { Component, inject } from '@angular/core';
import { SoilBasedCropCodeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SoilBasedCropCodeCreateDto,
  SoilBasedCropCodeDto,
  SoilBasedCropCodeExcelDownloadDto,
  SoilBasedCropCodeUpdateDto,
} from '../proxy/planning/dtos/soil-based-crop-code';
import { SOILBASEDCROPCODE_CONFIG, SOILBASEDCROPCODE_FIELDS } from './soil-based-crop-code.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-soil-based-crop-code',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SoilBasedCropCodeService, ConfirmationService],
  templateUrl: './soil-based-crop-code.html',
  styleUrl: './soil-based-crop-code.scss',
})
export class SoilBasedCropCode extends BaseCrudComponent<
  SoilBasedCropCodeDto,
  SoilBasedCropCodeCreateDto,
  SoilBasedCropCodeUpdateDto,
  SoilBasedCropCodeExcelDownloadDto
> {
  service = inject(SoilBasedCropCodeService);
  config = SOILBASEDCROPCODE_CONFIG;
  fields = SOILBASEDCROPCODE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SoilBasedCropCodeDto): SoilBasedCropCodeUpdateDto {
    return {
      dominantHeight: data.dominantHeight,
      mediumAnnualIncrement: data.mediumAnnualIncrement,
      soilType: data.soilType,
      treeCount: data.treeCount,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SoilBasedCropCode';
  }
}
